import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-chevron-left-icon',
  templateUrl: 'chevron-left-icon.component.html'
})
export class ChevronLeftIconComponent {
  constructor() {}
}
